import {PdfProperties} from "../types";

export const defPDFProperty: PdfProperties = {
    pageSize: 'A4',
    pageOrientation: 'landscape',
    pageMargins: [0, 0, 0, 36],
};
